import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, watch } from 'vue';
import SimpleDrawerPanel from './SimpleDrawerPanel.vue';
import MGWalkthrough from './MGWalkthrough.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WalkthroughDrawerPanel',
    props: {
        walkthroughData: {},
        slideKey: {}
    },
    emits: ["drawer-opened", "drawer-closed", "action-clicked"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const walkthroughTitle = ref('');
        const open = ref(false);
        // iPhone SE-class short screens need more vertical room for the carousel + slide.
        const drawerHeight = ref(window.innerHeight < 700 ? '95vh' : '75vh');
        function openDrawer() {
            open.value = true;
        }
        function closeDrawer() {
            open.value = false;
        }
        function handleActionClicked(actionUri) {
            emit('action-clicked', actionUri);
            closeDrawer();
        }
        function handleTitleLoaded(title) {
            walkthroughTitle.value = title;
        }
        // SimpleDrawerPanel has no @opened / @closed — mirror the old chrome by
        // watching modelValue and firing the same side effects on each transition.
        watch(open, (isOpen) => {
            if (isOpen) {
                document.body.classList.add('hide-nav-bar');
                emit('drawer-opened');
            }
            else {
                document.body.classList.remove('hide-nav-bar');
                emit('drawer-closed');
            }
        });
        function determineCarouselHeight() {
            if (window.innerHeight < 700) {
                return '150px';
            }
            else {
                return '240px';
            }
        }
        __expose({ openDrawer, closeDrawer });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(SimpleDrawerPanel, {
                modelValue: open.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((open).value = $event)),
                title: walkthroughTitle.value,
                height: drawerHeight.value
            }, {
                default: _withCtx(() => [
                    _createVNode(MGWalkthrough, {
                        walkthroughData: _ctx.walkthroughData,
                        variant: "sheet",
                        slideKey: _ctx.slideKey,
                        dotsAbove: false,
                        height: determineCarouselHeight(),
                        onSlideTitleChanged: handleTitleLoaded,
                        onClose: closeDrawer,
                        onActionClicked: handleActionClicked,
                        onCloseDrawer: closeDrawer
                    }, null, 8, ["walkthroughData", "slideKey", "height"])
                ]),
                _: 1
            }, 8, ["modelValue", "title", "height"]));
        };
    }
});
